<div class="modal fade" id="permissions-modal">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header hyperion-t4">
				Your Permissions
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<p>Below is a list of the permissions assigned to you per population. If you believe your permissions are incorrect, or you are missing any populations, please reach out for assistance.</p>
				<div class="row gy-3 mb-3">
					<div class="col-12 col-lg-6">
						<label for="filter-permissions-org-units">Filter populations</label>
						<ng-select
							id="filter-permissions-org-units"
							[items]="permissions"
							bindLabel="PopulationName"
							[(ngModel)]="selectedPermissions"
							[multiple]="true"
							[closeOnSelect]="false"
							(change)="updateFilterPopulations($event)"
						></ng-select>
					</div>
				</div>
				<ls-sortable-table
					[columns]="columns"
					[data]="shownPermissions"
					noResultsLabel="No permissions for the selected population."
				></ls-sortable-table>
    	</div>
			<div class="modal-footer">
				<wdpr-button data-bs-dismiss="modal">Close</wdpr-button>
      </div>
		</div>
	</div>
</div>
